export class OPathOperator {
  public identifier: string;
  public description: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export enum OperatorPosition {
  left = 'left',
  right = 'right',
  bottom = 'bottom',
}
